import { render } from "./Terms.vue?vue&type=template&id=cdfd9fa0&scoped=true"
const script = {}

import "./Terms.vue?vue&type=style&index=0&id=cdfd9fa0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\EFRENBP\\Desktop\\Projects\\2022\\03-Landing referidos\\AM-referidos\\am-referrals router\\am-referrals\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdfd9fa0"]])

export default __exports__